
         <div class="wrapper fadeInDown">
          <div id="formContent">
    
            <form autocomplete="off" [formGroup]="formAdmin" (ngSubmit)="onSubmit(formAdmin.value)" >

              <div class="form-group">
                <input type="text" formControlName="proyecto" class="formControl" id="exampleInputEmail1"  placeholder="Proyecto"  required>
              </div>

            <div class="form-group">
              <input type="email" formControlName="email" class="formControl" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Email" autocomplete="username email" #userName required>
            </div>
    
      
            <div class="formGroup">
              <input type="password" formControlName= "password" class="formControl" placeholder="Password" autocomplete="new-password" #userPassword required>
            </div>

			<div class="formGroup">
				<input type="text" formControlName= "telefono" class="formControl" placeholder="Teléfono" required>
			  </div>
        

      
            <!-- Calling SignIn Api from AuthService -->
            <div class="formGroup">
              <input type="submit" id="button" class="btn btnPrimary" value="Acceder">
            </div>
            </form>


            <div id="formFooter">
            <div class="redirectToLogin">
              <span>¿Ya tienes una cuenta? </span><a class="underlineHover" routerLink="/sign-in">Acceder</a>
            </div>
          </div>


      </div>
  
      
    </div>
  
 <app-index></app-index>